import * as types from "./mutations-types";

export default {
  [types.ADD_PRODUCT_TO_LIST](state, product) {
    
    // Verifica se o produto já existe na lista pelo product_id
    const productExists = state.selected_products.some(
      (p) => p.product_id === product.product_id
    );

    // Se o produto não existir, adiciona à lista
    if (!productExists) {
        // Recrie o array para garantir a reatividade
        state.selected_products = [
            ...state.selected_products,
            product
        ];
    }
  },

  [types.REMOVE_PRODUCT_FROM_LIST](state, product) {
    state.selected_products = 
    state.selected_products.filter(
        (prod) => prod.product_id !== product.product_id
    );
  },

  [types.REMOVE_ALL_PRODUCTS_FROM_LIST](state) {
    state.selected_products = []
  },

  [types.UPDATE_CUSTOM_MESSAGE](state, message) {
    state.steps.additional_info.message = message
  },
}